import Solution from '@/components/Solution';
import Layout from '@/components/Layout';
Solution.getLayout = function getLayout(page) {
    return (
        <Layout webViewMobile={true} web='solution' >{page}</Layout>
    );
};

export default Solution;


